import { render, staticRenderFns } from "./SamplesRegister.vue?vue&type=template&id=a6e34f70&scoped=true"
import script from "./SamplesRegister.vue?vue&type=script&lang=js"
export * from "./SamplesRegister.vue?vue&type=script&lang=js"
import style0 from "./SamplesRegister.vue?vue&type=style&index=0&id=a6e34f70&prod&scoped=true&lang=scss"
import style1 from "./SamplesRegister.vue?vue&type=style&index=1&id=a6e34f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e34f70",
  null
  
)

export default component.exports